import { render, staticRenderFns } from "./comp_TaloTransferInfo.vue?vue&type=template&id=fa36c5ae&scoped=true"
import script from "./comp_TaloTransferInfo.vue?vue&type=script&lang=js"
export * from "./comp_TaloTransferInfo.vue?vue&type=script&lang=js"
import style0 from "./comp_TaloTransferInfo.vue?vue&type=style&index=0&id=fa36c5ae&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa36c5ae",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
